// @flow
import { createRef, useState } from "react";
import {
  Heading,
  QuestionWrapper,
  RadioButtons,
  type RadioButtonsOptions,
  QuestionDescription,
} from "../components";
import { type QuestionProps } from "../components/MultiStageForm";
import { useDesktopFocus } from "../hooks/useDesktopFocus";
import { validatePresence } from "./validators";

const validate = validatePresence("valuationIntent", "Please select an option");

export const options: RadioButtonsOptions<CustomerIntentValue> = [
  {
    value: "ALREADY_ON_THE_MARKET",
    label: "I’m currently on the market",
  },
  {
    value: "THINKING_ABOUT_IT",
    label: "I’m thinking about selling",
  },
  {
    value: "LOOKING_TO_BUY",
    label: "I’m looking to buy this property",
  },
  {
    value: "JUST_CURIOUS",
    label: "I’m just curious!",
  },
];

type Props = {
  ...QuestionProps<"valuationIntent">,
  initialModalOpen?: boolean,
};

export const ValuationIntent = ({
  ActionButtons,
  BackButton,
  initialValue,
  next,
  valid,
  validationErrors,
}: Props) => {
  const [valuationIntent, setvaluationIntent] = useState(initialValue);

  const ref = createRef();
  useDesktopFocus(ref);

  return (
    <>
      <QuestionWrapper
        next={() => {
          next(valuationIntent, validate);
        }}
        dataTest="valuation-intent-question"
      >
        <BackButton />
        <Heading>Why are you looking for a valuation?</Heading>
        <QuestionDescription>
          This will help us give you the best guidance for your situation.
        </QuestionDescription>
        <RadioButtons
          data-test="valuation-intent-radios"
          errorMessage={validationErrors.valuationIntent}
          hasErrors={!valid}
          name="where-in-your-home-move"
          onChange={setvaluationIntent}
          options={options}
          ref={ref}
          value={valuationIntent}
        />
        <ActionButtons />
      </QuestionWrapper>
    </>
  );
};
